import alternateCountryTranslations from "infrastructure/translate/alternateCountyTranslations";
import { translate as t } from "../../../../../../../../infrastructure/translate/localization";
import authClient from "../../../../../../../auth/Auth";
import { showIFeelFeature } from "../../../../../../../../infrastructure/chosen-company";

const companyId = authClient.getCompanyId();
const showIfFeel = showIFeelFeature(companyId);

const columns = (country) => [
  { id: "legalId", label: t("common-messages.nif-nie") },
  { id: "nameAndSurname", label: t("common-messages.name-and-surname") },
  { id: "meals", label: t("common-messages.meals"), align: "center" },
  {
    id: "transport",
    label: t("benefits-section.transport-benefit.transport"),
    align: "center",
  },
  {
    id: "healthInsurance",
    label: showIfFeel
      ? t("benefits-section.ifeel-benefit.ifeel")
      : alternateCountryTranslations(country, "health-insurance"),
    align: "center",
  },
  {
    id: "nursery",
    label: t("benefits-section.nursery-benefit.nursery"),
    align: "center",
  },
  {
    id: "education",
    label: t("benefits-section.education-benefit.education"),
    align: "center",
  },
];

export default columns;
